/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import {
  RECEIVED_CONFIDENCE_SCORES,
  RECEIVED_MONTE_CARLO_CONFIDENCE_SCORES
} from 'state/account/ConfidenceScoresActions';

export const initialConfidenceScores = [],
  initialMonteCarloConfidenceScores = [];

export const confidenceScoresReducer = (state = [], action) => {
  if (action.type === RECEIVED_CONFIDENCE_SCORES) {
    return action.confidenceScores;
  }
  return state;
};

export const MonteCarloConfidenceScoresReducer = (state = [], action) => {
  if (action.type === RECEIVED_MONTE_CARLO_CONFIDENCE_SCORES) {
    return action.monteCarloConfidenceScores;
  }
  return state;
};
